import React from "react";
import c3 from "../img/c3.jpg";
function Plants() {
  return (
    <section
      className="grid grid-cols-1 md:grid-cols-2 gap-2 w-full "
      id="aqua"
    >
      <div className="py-2 flex-1 flex items-center relative">
        {
          <img
            src={c3}
            className="ml-auto h-420 w-full lg:w-auto lg:h-300"
            alt="img"
          />
        }
      </div>
      <div className="py-2 flex-1 flex flex-col items-start justify-center gap-6">
        <p className="text-[2rem] lg:text-[2rem] font-bold tracking-wide text-slate-700">
          Know How Your Food Grows
        </p>
        <p className="text-base text-slate-400 text-center md:text-left md:w-[80%]">
          Leafy Lettuce Lettuce that is grown in aquaponics is one of the most
          productive leafy green in an aquaponics system. Leafy lettuce will
          thrive in water, which has a temperature of between 70 and 74. All you
          need to do is decide whether you are starting your seedlings directly
          in the aquaponics system or a seed germinating tray. However, this can
          be beneficial to prevent seed loss in your grow media. Lettuce is
          suitable to grow in aquaponics if you are a beginner. Watercress This
          tough vegetable is one of the best plants for aquaponics because it
          grows so quickly. You can plant one single small plant, and it will
          multiply at an astonishing rate. However, you should consider whether
          this is the best for you. There is only so much watercress you can
          eat. Its ability to multiply can give you issues with your grow bed,
          which can become clogged. Tomatoes The humble tomato plant does
          exceptionally well in this water-based system. You will find it easier
          to control the temperature and even the amount of sun the plants get.
          To read more about tomatoes, read my article about Totatoes
          Aquaponics. However, it is worth noting that tomato plants tend to
          attract pests, which can be exceptionally difficult to get rid of.
        </p>
      </div>
    </section>
  );
}

export default Plants;
